const pageScrollState = (() => {
    const { body } = document;
    let pageScrollPosition = 0;
    const getScrollWidth = () => window.innerWidth - body.parentNode.clientWidth;
    const fix = () => {
        if (!body.parentElement.classList.contains('fixed')) {
            const scrollWidth = getScrollWidth();
            pageScrollPosition = window.scrollY;
            body.parentNode.classList.add('fixed');
            body.scrollTop = pageScrollPosition;
            body.style.paddingRight = `${scrollWidth}px`;
        }
    };
    const unfix = () => {
        if (body.parentElement.classList.contains('fixed')) {
            body.parentNode.classList.remove('fixed');
            window.scrollTo(0, pageScrollPosition);
            body.style.paddingRight = '0px';
        }
    };
    const toggle = () => {
        // eslint-disable-next-line no-unused-expressions
        body.parentNode.classList.contains('fixed') ? unfix() : fix();
    };
    const set = (position) => {
        window.scrollTo(0, position);
    };
    return {
        fix,
        unfix,
        toggle,
        set,
    };
})();

export default pageScrollState;
